/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TaskWorkflowItemConfigurationTargetingOneOf2
 */
export interface TaskWorkflowItemConfigurationTargetingOneOf2 {
    /**
     * 
     */
    target_type?: TaskWorkflowItemConfigurationTargetingOneOf2TargetTypeEnum;
    /**
     * 
     */
    facility_ids?: Array<any>;
    /**
     * 
     */
    facility_system_tags?: Array<any>;
    /**
     * 
     */
    facility_custom_tag_ids?: Array<any>;
}


/**
 * @export
 */
export const TaskWorkflowItemConfigurationTargetingOneOf2TargetTypeEnum = {
    SystemTag: 'SYSTEM_TAG',
} as const;
export type TaskWorkflowItemConfigurationTargetingOneOf2TargetTypeEnum = typeof TaskWorkflowItemConfigurationTargetingOneOf2TargetTypeEnum[keyof typeof TaskWorkflowItemConfigurationTargetingOneOf2TargetTypeEnum];


/**
 * Check if a given object implements the TaskWorkflowItemConfigurationTargetingOneOf2 interface.
 */
export function instanceOfTaskWorkflowItemConfigurationTargetingOneOf2(value: object): value is TaskWorkflowItemConfigurationTargetingOneOf2 {
    return true;
}

export function TaskWorkflowItemConfigurationTargetingOneOf2FromJSON(json: any): TaskWorkflowItemConfigurationTargetingOneOf2 {
    return TaskWorkflowItemConfigurationTargetingOneOf2FromJSONTyped(json, false);
}

export function TaskWorkflowItemConfigurationTargetingOneOf2FromJSONTyped(json: any, ignoreDiscriminator: boolean): TaskWorkflowItemConfigurationTargetingOneOf2 {
    if (json == null) {
        return json;
    }
    return {
        
        'target_type': json['target_type'] == null ? undefined : json['target_type'],
        'facility_ids': json['facility_ids'] == null ? undefined : json['facility_ids'],
        'facility_system_tags': json['facility_system_tags'] == null ? undefined : json['facility_system_tags'],
        'facility_custom_tag_ids': json['facility_custom_tag_ids'] == null ? undefined : json['facility_custom_tag_ids'],
    };
}

export function TaskWorkflowItemConfigurationTargetingOneOf2ToJSON(json: any): TaskWorkflowItemConfigurationTargetingOneOf2 {
    return TaskWorkflowItemConfigurationTargetingOneOf2ToJSONTyped(json, false);
}

export function TaskWorkflowItemConfigurationTargetingOneOf2ToJSONTyped(value?: TaskWorkflowItemConfigurationTargetingOneOf2 | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'target_type': value['target_type'],
        'facility_ids': value['facility_ids'],
        'facility_system_tags': value['facility_system_tags'],
        'facility_custom_tag_ids': value['facility_custom_tag_ids'],
    };
}

